import React from "react";

const SplitVisionAbout = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="relative overflow-hidden bg-gradient-to-br from-green-800 via-emerald-800 to-green-900 p-8 md:p-12 lg:p-16">
        <div className="absolute inset-0 -z-10 opacity-20">
          <div className="absolute top-40 left-10 h-72 w-72 rounded-full bg-emerald-400 blur-3xl" />
          <div className="absolute bottom-20 right-10 h-80 w-80 rounded-full bg-teal-400 blur-3xl" />
        </div>

        <div className="relative space-y-6">
          <div className="absolute -left-4 top-0 h-24 w-1 bg-gradient-to-b from-emerald-300 to-teal-300 rounded-full" />
          <h2 className="text-3xl font-extrabold tracking-tight text-white md:text-4xl">
            <span className="bg-gradient-to-r from-emerald-300 to-teal-300 bg-clip-text text-transparent">
              Our
            </span>{" "}
            Vision
          </h2>
          <div className="prose prose-invert prose-base max-w-none text-gray-100">
            <p className="text-base leading-relaxed md:text-lg">
              It is our wishful thinking to visualize{" "}
              <span className="font-semibold text-emerald-300">100% literacy</span> in the
              nation by fulfilling our sacred duty of providing a{" "}
              <span className="font-semibold text-emerald-300">platform</span> which is
              essential and aims at{" "}
              <span className="font-semibold text-emerald-300">multi-dimensional objectives</span>{" "}
              to take{" "}
              <span className="font-semibold text-emerald-300">youngsters</span> to{" "}
              <span className="font-semibold text-emerald-300">glorious heights</span> in
              different fields and transforming them into tomorrow's{" "}
              <span className="font-semibold text-emerald-300">entrepreneurs</span> who will
              be{" "}
              <span className="font-semibold text-emerald-300">proficient</span> in their
              respective fields.
            </p>
            <p className="mt-4 text-base leading-relaxed md:text-lg">
              We believe that education is the cornerstone of a prosperous society.
              By empowering the youth with practical skills and entrepreneurial mindset,
              we aim to create a generation that not only earns a livelihood but also
              contributes to the nation's economic growth. Our vision extends beyond
              classrooms; we envision a network of skilled professionals who become
              job creators rather than job seekers, driving innovation in every sector
              they enter.
            </p>
          </div>

          <button className="group inline-flex items-center gap-2 rounded-full border border-emerald-400/50 bg-transparent px-6 py-2.5 text-sm font-semibold text-emerald-100 transition-all hover:border-emerald-300 hover:bg-emerald-500/20 hover:text-white">
            Read More
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 transition-transform group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="relative overflow-hidden bg-gradient-to-br from-orange-100 via-amber-50 to-orange-100 p-8 md:p-12 lg:p-16">
        <div className="absolute inset-0 -z-10 opacity-30">
          <div className="absolute top-40 right-10 h-72 w-72 rounded-full bg-amber-300 blur-3xl" />
          <div className="absolute bottom-20 left-10 h-80 w-80 rounded-full bg-yellow-300 blur-3xl" />
        </div>
        <div className="relative space-y-8">
          <div className="absolute -left-4 top-0 h-20 w-1 bg-gradient-to-b from-amber-600 to-yellow-600 rounded-full" />
          <h2 className="text-3xl font-extrabold tracking-tight text-green-800 md:text-4xl">
            About{" "}
            <span className="bg-gradient-to-r from-amber-700 to-orange-700 bg-clip-text text-transparent">
              Sharda Private ITI
            </span>
          </h2>

          <p className="text-base leading-relaxed text-green-800 md:text-lg">
            Sharda Private ITI Bhaupur - Jaunpur is situated in Jaunpur, Uttar Pradesh.
            We offer ITI trades in{" "}
            <span className="font-semibold text-amber-700">Electrician</span> and{" "}
            <span className="font-semibold text-amber-700">Fitter</span>. Established in{" "}
            <span className="font-semibold text-amber-700">2012</span>, we are recognized
            as one of the best Industrial Training Institutes in Jaunpur.
          </p>

          <div className="space-y-4 text-green-800">
            <p>
              With a sprawling campus equipped with modern workshops and experienced faculty,
              we provide hands‑on training that bridges the gap between theoretical knowledge
              and industrial requirements. Our institute is approved by NCVT (National Council
              for Vocational Training) and follows the latest curriculum to ensure our students
              are job‑ready from day one.
            </p>
            <p>
              Over the last decade, we have produced thousands of skilled electricians and
              fitters who are now working in reputed companies across India. Our alumni
              network is a testament to our commitment to quality education and holistic
              development.
            </p>
          </div>

          <button className="group inline-flex items-center gap-2 rounded-full border border-amber-300 bg-white px-6 py-2.5 text-sm font-semibold text-amber-700 shadow-sm transition-all hover:border-amber-400 hover:bg-amber-50 hover:shadow-md">
            Read More
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 transition-transform group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SplitVisionAbout;